import { render, staticRenderFns } from "./LiveTicketTable.vue?vue&type=template&id=9a807c8a"
import script from "./LiveTicketTable.vue?vue&type=script&lang=js"
export * from "./LiveTicketTable.vue?vue&type=script&lang=js"
import style0 from "./LiveTicketTable.vue?vue&type=style&index=0&id=9a807c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports